import React from "react";
import {Spinner} from "react-bootstrap";

const CardLoader = () => {

    return (
        <div className="loading-wrapper top-25p">
            <div className="modal-body">
                <Spinner animation="border" variant="dark"/>
            </div>
        </div>
    );
}

export default CardLoader